const actions = {
  PATCH_CAROUSEL: "carousel/PATCH_CAROUSEL",
  DELETE_CAROUSEL: "carousel/DELETE_CAROUSEL",
  CREATE_CAROUSEL: "carousel/CREATE_CAROUSEL",
  GET_CAROUSEL: "carousel/GET_CAROUSEL",
  SET_STATE: "carousel/SET_STATE"
};

export default actions;
